<template>
  <div dense class="LKPublicationsDataCollection">
    <div class="LKPublicationsDataCollection__inner-wrapper">
      <div class="LKPublicationsDataCollection__left">
        <LKPublicationsDataCollectionLeft
          :data="data"
        />
      </div>

      <div class="LKPublicationsDataCollection__right">
        <LKPublicationsDataCollectionRight
          :data="data"
          :publication-id="publicationId"
          :is-curator="isCurator"
          :is-filling-available="isFillingAvailable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { lkMapper } from '@/store/modules/lk'
import LKPublicationsDataCollectionLeft from './LKPublicationsDataCollectionLeft.vue'
import LKPublicationsDataCollectionRight from './LKPublicationsDataCollectionRight.vue'


export default {
  name: 'LKPublicationsDataCollection',
  components: {
    LKPublicationsDataCollectionLeft,
    LKPublicationsDataCollectionRight,
  },
  inheritAttrs: false,
  props: {
    data: {
      type: Object,
      required: true,
      validator: (prop) => (
        prop
      ),
    },
    publicationId: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    ...lkMapper.mapGetters(['profile']),
    isCurator() {
      return this.profile.is_superuser || this.data.is_curator_view
    },
    isFillingAvailable() {
      return this.data.is_filling_available
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsDataCollection {
  position: relative;
  overflow-x: auto;
  background-color: $webflow-color-blue-shadow;

  &__inner-wrapper {
    display: flex;
    padding: 18px 22px 25px 22px;
  }

  &__left {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  &__right {
    padding-left: 24px;
    margin-left: 24px;
    border-left: 1px solid $webflow-color-blue-light;
  }
}
</style>
